module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Ticket-3143c355de30f9a06bd34671b05be418.svg";